
// const baseURL='http://88.99.5.236:9857'
// const baseURL='https://choplottodashboardbackend.visiontrek.io'

// const baseURL=`http://84.247.182.44:9873`
// const baseURL=`http://192.168.1.27:9873`
const baseURL=``

export {baseURL}

const SubscriptionApi=`${baseURL}`
export {SubscriptionApi}

